import { TableCell } from '@mui/material';
import { FunctionComponent } from 'react';
import { ISecrEmissionData } from '../../../../shared/services/generated-report/generated-report.model';
import { SECR_EM_DASH, formatSecrReportNumber } from './secr-number-format';

function formatMainTableValue(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(Number(v))) {
    return SECR_EM_DASH;
  }
  return formatSecrReportNumber(Number(v));
}

export const ReportingSecrTableSegment: FunctionComponent<{
  data: ISecrEmissionData,
  showOverseas: boolean,
  backgroundColor: string,
  /** Stronger typography for SECR source matrix total row */
  variant?: 'default' | 'total',
  /** Tighter cell padding (source matrix only) */
  dense?: boolean,
}> = ({
  data,
  showOverseas,
  backgroundColor,
  variant = 'default',
  dense = false,
}) => {

    const isTotal = variant === 'total';

    const textUk = formatMainTableValue(data.uk as number | null | undefined);
    const textOs = formatMainTableValue(data.overseas as number | null | undefined);
    const textGl = formatMainTableValue(data.global as number | null | undefined);

    const cellSx = (display: string) => ({
      backgroundColor,
      textAlign: 'right' as const,
      fontVariantNumeric: 'tabular-nums',
      color: display === SECR_EM_DASH ? 'text.secondary' : 'primary.dark',
      ...(isTotal ? { fontWeight: 700 } : {}),
      ...(dense ? { py: 0.65, px: 1 } : {}),
    });

    return (
      <>
        <TableCell scope='row' sx={cellSx(textUk)}>
          {textUk}
        </TableCell>
        {showOverseas &&
          <>
            <TableCell scope='row' sx={cellSx(textOs)}>
              {textOs}
            </TableCell>
            <TableCell scope='row' sx={cellSx(textGl)}>
              {textGl}
            </TableCell>
          </>}
      </>
    )
  }